import React, { useContext } from 'react';
import { LoadFunctionType } from 'app/containers/state/AutoLoader';
import {
  AutoLoaderCache,
  loadIntoCache,
} from './AutoLoaderCache';
import { CacheKey } from './common';

/**
 * This does nothing more than forward requests to the given AutoLoaderCache.
 * However, it is separate from AutoLoaderCache because AutoLoaderCache is used
 * on both the client and for SSR, but ServerRenderLoader should only be used
 * for SSR.
 *
 * It is not being used yet, but will be used when we start using ReactDOMServer
 * for SSR.
 */
export class ServerRenderLoader {
  private cache: AutoLoaderCache;

  public constructor(cache: AutoLoaderCache) {
    this.cache = cache;
  }

  public addLoad({
    cacheKey,
    args,
    load,
  }: {
    cacheKey: CacheKey,
    args: unknown,
    load: LoadFunctionType,
  }): void {
    // If given cacheKey + args is already in the cache, then this won't cause a
    // new request to be made. This means we can re-render the app multiple
    // times with ReactDOMServer without re-doing old requests.
    loadIntoCache(this.cache, {
      cacheKey,
      cacheTimeout: Infinity, // never expire
      args,
      load,
    });
  }
}

const ServerRenderLoaderContext = React.createContext<ServerRenderLoader | undefined>(undefined);
export const ServerRenderLoaderProvider = ServerRenderLoaderContext.Provider;
export const useServerRenderLoader = () => useContext(ServerRenderLoaderContext);
